import { Timestamp } from '@firebase/firestore-types'
import { DocumentReference } from 'firebase/firestore';
import type { RecordingSessionType } from 'gql/graphql';
import { type SubTakeData } from '../RecordingSessionDataGrid/types';

export type Filter = {
    seasons: string[]
    episodes: string[]
    characters: string[]
}

export type DraftRecordingSession = {
    id?: string
    ref?: DocumentReference<DraftRecordingSession>
    name: string
    filter: Filter
    scratch: boolean
    takeCount: number
    actor?: string
    studio?: string
    engineer?: string
    beginTime?: string
    endTime?: string
    notes?: string
    updatedAt?: Timestamp
}

export type SelectInfoItem = {
    id?: string
    ref?: DocumentReference
    circle?: string
    alt?: string[]
}

export type EpisodeData = {
    episodeId: string
    updatedAt?: Timestamp
    type?: RecordingSessionType
}

export type TakeGroup = {
    id?: string
    ref?: DocumentReference
    take: string
    lineIds: string[]
    subTakes: SubTakeData[]
    ordinal: number
}

export const DefaultDraftSession: DraftRecordingSession = {
    name: '',
    filter: {
        seasons: [],
        episodes: [],
        characters: [],
    },
    scratch: false,
    takeCount: 0,
}

export const DefaultEpisodeData: EpisodeData = {
    episodeId: '',
}